export default "__VITE_ASSET__Cb22nAfw__"